/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    shape, string, number,
} from 'prop-types';

const Address = (props) => {
    const {
        recipient: { address },
    } = props;

    if (!address) return null;

    const {
        street, apt, city, state, zipcode, country,
    } = address;
    return (
        <div>
            <div>
                {street}
                {apt ? ` ${apt}, ` : ', '}
                {`${city}, ${state.id} ${zipcode}`}
            </div>
            <div className="display-none">{country.name}</div>
        </div>
    );
};

Address.defaultProps = {
    recipient: {},
};

Address.propTypes = {
    recipient: shape({
        address: shape({
            addressId: string,
            apt: string,
            city: string,
            company: string,
            country: shape({
                id: string,
                name: string,
            }),
            location: shape({
                id: number,
                name: string,
            }),
            state: shape({
                id: string,
                name: string,
            }),
            street: string,
            zipcode: string,
        }),
    }),
};

export default Address;
